<template>
    <template v-if="counter > 0">
        {{counter}}
    </template>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const emit = defineEmits(['completed'])

const props = defineProps<{
  start?: string
  durationSeconds?: number
}>()

let counter = ref(0)

if(props.start && props.durationSeconds) {
    counter.value = Math.floor((Date.parse(props.start) + props.durationSeconds * 1000 - (new Date().getTime())) / 1000)
}

let interval = setInterval(() => {
    counter.value--
    if (counter.value < 1) {
        emit("completed")
        clearInterval(interval)
    }

}, 1000)
</script>
